import StarIcon from '@material-ui/icons/Star'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'

export const EarlyLifecycleDriverLabel = () => (
  <FlexBox gap="5px">
    <StarIcon style={{ color: '#daa520' }} />
    <Text variant="label2">Early Lifecycle Driver</Text>
    <StarIcon style={{ color: '#daa520' }} />
  </FlexBox>
)
